import React,{useEffect} from "react";
import SidebarComp from "../../components/sidebar/sidebar";
import NavbarComp from "../../components/navbar/navbar";
import DashboardOngoingRides from "../../components/body/alldatacomponent/rides/dashboardOngoingRides";

const OngoingRideScreen=()=>{
   
    
    return(
        <div className="container-scroller">
            <NavbarComp />
            <div className="container-fluid page-body-wrapper">
                <SidebarComp />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <DashboardOngoingRides />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OngoingRideScreen;